import { render, staticRenderFns } from "./PublicBroadcastSettings.vue?vue&type=template&id=447836f4&scoped=true"
import script from "./PublicBroadcastSettings.vue?vue&type=script&lang=js"
export * from "./PublicBroadcastSettings.vue?vue&type=script&lang=js"
import style0 from "./PublicBroadcastSettings.vue?vue&type=style&index=0&id=447836f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447836f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('447836f4')) {
      api.createRecord('447836f4', component.options)
    } else {
      api.reload('447836f4', component.options)
    }
    module.hot.accept("./PublicBroadcastSettings.vue?vue&type=template&id=447836f4&scoped=true", function () {
      api.rerender('447836f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/MeetingRoom/PublicBroadcastSettings.vue"
export default component.exports